module.exports = __webpack_public_path__ + "img/Frame10.3e8ad17f.png";